import { Switch, Route, BrowserRouter as Router } from 'react-router-dom';
import { CssBaseline, Grid, PaletteMode, ThemeProvider } from '@mui/material';
import { MsalAuthenticationTemplate, MsalProvider } from '@azure/msal-react';
import { InteractionType } from '@azure/msal-browser';
import { Timeline } from './pages/timeline/Timeline';
import NavBar from './components/NavBar';
import WelcomeName from './components/WelcomeName';
import ConfigurationBarrier from './components/ConfigurationBarrier';
import PublicClientApplicationWrapper from './components/PublicClientApplicationWrapper';
import useTheme from './hooks/useTheme';
import { useState } from 'react';
import ManagementTabs from './pages/management';
import Admin from './pages/admin/Admin';
import Display from './pages/display/Display';
import Client from './pages/clients/Clients';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import EmployeeQueries from '../src/pages/management/employees/EmployeeQueries';

const App: React.FC = () => {
  const [themeMode, setThemeMode] = useState<PaletteMode>('light'); // TODO Can hook this up to switch to dark mode
  const theme = useTheme(themeMode);

  return (
    <>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <ConfigurationBarrier>
          <PublicClientApplicationWrapper>
            {pca => (
              <MsalProvider instance={pca}>
                <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
                  <Pages />
                  <ToastContainer position="bottom-right" autoClose={3500} pauseOnHover={false} />
                </MsalAuthenticationTemplate>
              </MsalProvider>
            )}
          </PublicClientApplicationWrapper>
        </ConfigurationBarrier>
      </ThemeProvider>
    </>
  );
};

const Pages: React.FC = () => {
  const { IsManager } = EmployeeQueries();
  let { data: manager } = IsManager();
  return (
    <Router>
      <NavBar>
        <Grid container>
          <Switch>
            <Switch>
              {manager && (
                <Route exact path="/management">
                  <ManagementTabs />
                </Route>
              )}

              {manager && (
                <Route exact path="/admin">
                  <Admin />
                </Route>
              )}

              <Route path="/timeline">
                <Timeline />
              </Route>

              <Route path="/display">
                <Display />
              </Route>

              <Route path="/clients">
                <Client />
              </Route>

              <Route path="/">
                <WelcomeName />
              </Route>
            </Switch>
          </Switch>
        </Grid>
      </NavBar>
    </Router>
  );
};

export default App;
